export const Townhouse = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = ' ' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 24 24'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M20.003 10.545v10.459M22.004 12l-9.379-6.818a1 1 0 00-1.173 0L1.996 12M19.504 9.742V4.497a.5.5 0 00-.5-.5h-3.002a.5.5 0 00-.5.5v2.61M22.004 21.004H1.996M3.996 10.558v10.446'
        ></path>
        <rect
          width='4.002'
          height='3.001'
          x='13.501'
          y='15.002'
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          rx='0.5'
        ></rect>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M6.998 21.004v-5.502a.5.5 0 01.5-.5H10a.5.5 0 01.5.5v5.502'
        ></path>
      </svg>
    </span>
  );
};
